import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ROLES_ACTION } from '../actions';
import { ActivatedRouteSnapshot } from '@angular/router';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { filter, firstValueFrom, forkJoin, take } from 'rxjs';
import { getPermissionsSelector, getRolesSelector } from '../selectors';
import { Actions, ofType } from '@ngrx/effects';

export const rolesResolver = async () => {
  const store = inject(Store);
  store.dispatch(ROLES_ACTION.loadRoles());
  store.dispatch(ROLES_ACTION.loadPermissionList());

  return firstValueFrom(
    forkJoin([
      store.select(getPermissionsSelector).pipe(take(1)),
      store.select(getRolesSelector).pipe(take(1)),
    ]),
  );
};

export const editRoleResolver = async (
  _activatedRouteSnapShot: ActivatedRouteSnapshot,
) => {
  const store = inject(Store);
  const storeActions = inject(Actions);
  const editMode = coerceBooleanProperty(
    _activatedRouteSnapShot.queryParamMap.get('editMode'),
  );
  const roleId = _activatedRouteSnapShot.queryParamMap.get('roleId') as string;
  if (editMode) {
    store.dispatch(
      ROLES_ACTION.fetchUserRole({
        roleId: roleId,
      }),
    );
    return firstValueFrom(
      storeActions.pipe(
        ofType(ROLES_ACTION.onFetchUserRoleSuccess),
        filter(Boolean),
      ),
    );
  }
  return null;
};
